import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { token } from "./token.js";
function Image({
  src,
  alt = ""
}) {
  return /* @__PURE__ */ jsx(ImageHolder, {
    children: /* @__PURE__ */ jsx(StyledImage, {
      src,
      alt,
      "data-testid": "ds-tooltip-image"
    })
  });
}
const ImageHolder = styled.div.withConfig({
  displayName: "ImageHolder",
  componentId: "sc-1m204zj-0"
})(["margin:calc(", " * -1) calc(", " * -1) ", ";"], token.spacing4, token.spacing5, token.spacing3);
const StyledImage = styled.img.withConfig({
  displayName: "StyledImage",
  componentId: "sc-1m204zj-1"
})(["vertical-align:top;width:100%;border-bottom:1px solid ", ";border-radius:var(--ds-tooltip-border-radius) var(--ds-tooltip-border-radius) 0 0;"], token.gray100a);
export {
  Image
};
//# sourceMappingURL=Image.js.map
